module.exports = __webpack_public_path__ + "img/20191120162209218.4f03bc2a.jpg";